import React, { useState, useEffect, useRef } from 'react'
import {
  withStyles,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@material-ui/core'
import styles from './styles'
import { CoreTextField, CoreButton } from 'src/components/core'
import { inviteCollaboratorAction } from 'src/reducers/collection/action'
import { useDispatch, useSelector } from 'react-redux'
import { Typography } from '@material-ui/core'
import { Icon } from '@iconify/react'

const CollaboratorTypes = [
  {
    label: 'Editor',
    value: 1,
    description: 'Can create and edit courses and landing pages.',
  },
  {
    label: 'Analyst',
    value: 2,
    description: 'Can view learners data and access analytics.',
  },
  {
    label: 'Editor & Analyst',
    value: 3,
    description:
      'Can create and edit content, manage learners, and view analytics.',
  },
]

const InviteSection = props => {
  const { classes } = props
  const dispatch = useDispatch()
  const selectRef = useRef(null)
  const [selectWidth, setSelectWidth] = useState(0)
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('')
  const [type, setType] = useState('')
  const [emailSent, setEmailSent] = useState(false)
  const [isValidEmail, setIsValidEmail] = useState(false)
  const [showEmailError, setShowEmailError] = useState(false)
  const [isSelfInvite, setIsSelfInvite] = useState(false)
  const collection = useSelector(state => state.collection.collection)
  const user = useSelector(state => state.authentication.me)

  const userEmail = user?.email

  useEffect(() => {
    if (selectRef.current) {
      setSelectWidth(selectRef.current.offsetWidth)
    }
  }, [])

  const validateEmail = email => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  const handleEmailChange = e => {
    const newEmail = e.target.value
    setEmail(newEmail)
    setIsSelfInvite(newEmail === userEmail)
    if (showEmailError) {
      setIsValidEmail(validateEmail(newEmail))
    }
  }

  const handleEmailBlur = () => {
    setShowEmailError(true)
    setIsValidEmail(validateEmail(email))
  }

  const handleInvite = () => {
    if (!email || !type || !isValidEmail) {
      return
    }
    setLoading(true)
    dispatch(
      inviteCollaboratorAction(collection.id, { email, type }, () => {
        setEmail('')
        setType('')
        setLoading(false)
        setEmailSent(true)
        setIsValidEmail(false)
        setShowEmailError(false)
      }),
    )
  }

  useEffect(() => {
    if (emailSent) {
      setTimeout(() => {
        setEmailSent(false)
      }, 3000)
    }
  }, [emailSent])
  return (
    <div className={classes.form}>
      <div className={classes.emailControl}>
        <CoreTextField
          label="Email"
          fullWidth
          variant="outlined"
          marginTop={false}
          value={email}
          onChange={handleEmailChange}
          onBlur={handleEmailBlur}
          error={showEmailError && (!isValidEmail || isSelfInvite)}
        />
        {showEmailError && !isValidEmail && (
          <Typography color="error">
            Please enter a valid email address
          </Typography>
        )}
        {isSelfInvite && (
          <Typography color="error">You cannot invite yourself</Typography>
        )}
      </div>

      <FormControl variant="outlined" fullWidth>
        <InputLabel>Role</InputLabel>
        <Select
          ref={selectRef}
          value={type}
          onChange={e => setType(e.target.value)}
          label="Role"
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
            PaperProps: {
              style: {
                width: selectWidth,
                padding: '4px',
                borderRadius: '8px',
              },
            },
          }}
          renderValue={selected => {
            const selectedRole = CollaboratorTypes.find(
              role => role.value === selected,
            )
            return selectedRole ? selectedRole.label : ''
          }}
        >
          {CollaboratorTypes.map(role => (
            <MenuItem
              key={role.value}
              value={role.value}
              style={{
                padding: '4px',
                borderRadius: '8px',
                marginBottom: '4px',
              }}
            >
              <div className={classes.roleMenuItem}>
                <Typography style={{ fontWeight: 500 }}>
                  {role.label}
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  style={{
                    whiteSpace: 'break-spaces',
                  }}
                >
                  {role.description}
                </Typography>
              </div>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <CoreButton
        variant="contained"
        color={emailSent ? 'success' : 'primary'}
        size="large"
        disabled={
          !emailSent && (!email || !type || !isValidEmail || isSelfInvite)
        }
        className={classes.inviteButton}
        onClick={handleInvite}
      >
        {emailSent ? 'Invite Sent' : 'Send Invite'}
      </CoreButton>
    </div>
  )
}

export default withStyles(styles)(InviteSection)
